import React from 'react';
import { useTheme, THEMES } from '../context/ThemeContext';
import './ThemeSwitcher.css';

function PaletteIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="1" />
      <path d="M12 3a9 9 0 0 0-9 9 9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.85A9.79 9.79 0 0 0 21 12" />
      <path d="M19.5 8a2.5 2.5 0 0 1 0 5" />
      <path d="M4.5 14a2.5 2.5 0 0 0 5 0" />
      <path d="M12 17v4" />
      <path d="M8.5 14.5L5 18" />
    </svg>
  );
}

export default function ThemeSwitcher() {
  const { theme, toggleTheme } = useTheme();
  const [isOpen, setIsOpen] = React.useState(false);

  return (
    <div className="theme-switcher">
      <button
        className="theme-switcher-btn"
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Theme switcher"
      >
        <span className="theme-icon">
          <PaletteIcon />
        </span>
        <span className="theme-label">Themes</span>
      </button>

      {isOpen && (
        <div className="theme-menu">
          {Object.entries(THEMES).map(([key, themeData]) => (
            <button
              key={key}
              className={`theme-option ${theme === key ? 'active' : ''}`}
              onClick={() => {
                toggleTheme(key);
                setIsOpen(false);
              }}
            >
              <span className="theme-option-dot" />
              <span className="theme-option-name">{themeData.name}</span>
              {theme === key && <span className="theme-check">✓</span>}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
